import Placeholder from "./placeholder";

export default Placeholder;
